// extracted by mini-css-extract-plugin
module.exports = {"controlButtons":"controlButtons--zDCWEHsk2R22xv_B5ay_"};